import { DEFAULT_BANNER_IMAGE } from '../constants/appConstant';

const lobsMap = {
  flights: { text: 'Flights', className: 'flightIcon' },
  hotels: { text: 'Hotels', className: 'hotelIcon' },
  activities: { text: 'Activities', className: 'activityIcon' },
  airportTransfers: { text: 'Transfers', className: 'cabIcon' },
  cityDrops: { text: 'Transfers', className: 'cabIcon' },
  carItinerary: { text: 'Transfers', className: 'cabIcon' },
  visa: { text: 'Visa', className: 'visaIcon' },
};

export const getImageCropUrl = (imageUrl, size) => `${imageUrl}?crop=${size}&downsize=${size}`;
const getImage = (image, isSeo) => {
  if (!image) {
    return {};
  }
  return {
    url: getImageCropUrl(image.fullPath, isSeo ? '259:168' : '370:240'),
    title: image.title,
  };
};

const getIncludedLobs = inclusionObj => {
  const includedLobs = [];
  if (inclusionObj) {
    for (const lob in inclusionObj) {
      if (inclusionObj.hasOwnProperty(lob)) {
        const isIncluded = inclusionObj[lob];
        if (isIncluded && lobsMap[lob]) {
          includedLobs.push(lobsMap[lob]);
        }
      }
    }
  }

  return [lobsMap.hotels].concat(includedLobs);
};

const getFormattedDurationText = nightCount => `${nightCount}N/${nightCount + 1}D`;

const formatTopSectionImg = (image, imageSize) => {
  if (!image) {
    return {
      backgroundImage: `url(${DEFAULT_BANNER_IMAGE})`,
    };
  }
  const backgroundImage = `url(${getImageCropUrl(
    image.trim(),
    imageSize
  )}),url(${DEFAULT_BANNER_IMAGE})`;
  return {
    backgroundImage,
  };
};

const getFormatterOmnitureText = (id, order, isPremium, isDod, safe, groupOmniDetail) => {
  let omniText = '';
  if (groupOmniDetail) {
    const { groupOrder, groupName, groupId } = groupOmniDetail;
    omniText = `Group_${groupOrder}_${groupId}_${groupName}|Package_${order}_${id}${
      isPremium ? '_Premiumpackage' : ''
    }${safe ? '_Safepackage' : ''}${isDod ? '_DOD' : ''}`;
    return omniText;
  } else {
    const omniText = `Package_${order}_${id}${isPremium ? '_PremiumPackage' : ''}${
      safe ? '_Safepackage' : ''
    }${isDod ? '_DOD' : ''}`;
    return omniText;
  }
};

const getFormattedDestinationText = str =>
  str.replace(/\w\S*/g, txt => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());

const getFormattedDestinationDetails = (destinations = []) => {
  const reqString = '';
  const stringArr = [];
  let tooltipText = '';
  let destinationText = '';
  if (destinations.length <= 2) {
    destinations.forEach(destination => {
      stringArr.push(
        reqString.concat(`${destination.nights}N ${getFormattedDestinationText(destination.name)}`)
      );
    });
    destinationText = stringArr.join(' - ');
    return {
      tooltipText,
      destinationText,
    };
  }
  if (destinations.length > 2) {
    destinations.forEach(destination => {
      stringArr.push(
        reqString.concat(`${destination.nights}N ${getFormattedDestinationText(destination.name)}`)
      );
    });
    tooltipText = stringArr.join(' - ');
    destinationText = stringArr.slice(0, 2).join(' - ');
    destinationText = destinationText.concat(
      ` - <span class="latoBold">+${stringArr.length - 2} More</span>`
    );
    return {
      tooltipText,
      destinationText,
    };
  }
  return {
    tooltipText,
    destinationText,
  };
};
export default {
  getFormatterOmnitureText,
  getImage,
  getFormattedDurationText,
  getIncludedLobs,
  formatTopSectionImg,
  getFormattedDestinationDetails,
};
